import AdminTableFiltersCard from "../ui/AdminTableFiltersCard";

type AdminNotificationsFiltersProps = {
  search: string;
  status: string;
  type: string;
  createdFromDate: string;
  createdToDate: string;
  pageSize: number;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onTypeChange: (value: string) => void;
  onCreatedFromDateChange: (value: string) => void;
  onCreatedToDateChange: (value: string) => void;
  onPageSizeChange: (value: number) => void;
};

const AdminNotificationsFilters = ({
  search,
  status,
  type,
  createdFromDate,
  createdToDate,
  pageSize,
  onSearchChange,
  onStatusChange,
  onTypeChange,
  onCreatedFromDateChange,
  onCreatedToDateChange,
  onPageSizeChange,
}: AdminNotificationsFiltersProps) => {
  return (
    <AdminTableFiltersCard>
      <div className="flex flex-wrap items-end gap-3">
        <div className="min-w-[320px] flex-[2_1_360px]">
          <label htmlFor="admin-notifications-filter-search" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Search
          </label>
          <input
            id="admin-notifications-filter-search"
            type="text"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Recipient, subject, type, last error"
            className="w-full rounded-lg border border-myteengig-border bg-white px-4 py-3 text-base text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          />
        </div>
        <div className="min-w-[160px] flex-[1_1_180px]">
          <label htmlFor="admin-notifications-filter-type" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Type
          </label>
          <input
            id="admin-notifications-filter-type"
            type="text"
            value={type}
            onChange={(event) => onTypeChange(event.target.value)}
            placeholder="EMAIL_VERIFICATION"
            className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          />
        </div>

        <div className="min-w-[140px] flex-[1_1_160px]">
          <label htmlFor="admin-notifications-filter-status" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Status
          </label>
          <select
            id="admin-notifications-filter-status"
            value={status}
            onChange={(event) => onStatusChange(event.target.value)}
            className="h-[50px] rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          >
            <option value="">All statuses</option>
            <option value="PENDING">PENDING</option>
            <option value="SENT">SENT</option>
            <option value="FAILED">FAILED</option>
          </select>
        </div>
        <div className="min-w-[160px] flex-[1_1_180px]">
          <label htmlFor="admin-notifications-filter-created-from" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Created From
          </label>
          <input
            id="admin-notifications-filter-created-from"
            type="date"
            value={createdFromDate}
            onChange={(event) => onCreatedFromDateChange(event.target.value)}
            className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          />
        </div>

        <div className="min-w-[160px] flex-[1_1_180px]">
          <label htmlFor="admin-notifications-filter-created-to" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Created To
          </label>
          <input
            id="admin-notifications-filter-created-to"
            type="date"
            min={createdFromDate || undefined}
            value={createdToDate}
            onChange={(event) => onCreatedToDateChange(event.target.value)}
            className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          />
        </div>

        <div className="min-w-[110px] flex-[0_1_120px]">
          <label htmlFor="admin-notifications-filter-page-size" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Rows
          </label>
          <select
            id="admin-notifications-filter-page-size"
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
            className="h-[50px] rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </select>
        </div>
      </div>
    </AdminTableFiltersCard>
  );
};

export default AdminNotificationsFilters;
